import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Grid } from '../../utils/material-ui-core';
import Wait from '../wait';

const SplashWait = () => {
  const pageStyles = LocalPageStyles();

  return (
    <Grid container spacing={0} direction="row" alignContent="center" justifyContent="center" className={pageStyles.rootContainer}>
      <Grid item>
        <Wait />
      </Grid>
    </Grid>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    rootContainer: {
      flexGrow: 1,
      justifyContent: "base-line",
      height: "100vh",
    },
  })
);

export default SplashWait;
